
    import Vue from 'vue';
    import { PropType } from 'vue';
    import { Offer } from '@/apps/shared/models/offer'
    import theftQuotationService from '@/apps/shared/services/theftQuotation-service';
    import DiscountRangeService from '@/apps/shared/services/getDiscountRange-service';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import GoodTypesService from '@/apps/shared/services/goodTypes-service';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import coverNoteService from '@/apps/shared/services/coverNote-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';

    export default Vue.extend({
        components: {
            XBreadcrumb,
            WhatsApp
        },
        name: 'Offer',
        props: {
            offer: {
                type: Object as PropType<Offer>,
                required: false,
            },
        },

        data() {
            return {
                modulesPlan: [],
                coberturas: [],
                Plandata: [],
                selectedPlan: null,
                finallyCalculationResult: [],
                quotationDataResult: [],
                plans: [],
                col: 2,
                plansLength: null,
                notCover: null,
                descriptionPlanNote: null,
                decimalPremioMensual: null,
                tabOneWelcome: null,
                dataGood: null,
                rangeSelected: null,
                isOffer: false,
                offerVisible: true,
                breadcrumItems: [
                    { text: 'Inicio', path: '/tecnologia' },
                    { text: 'Cotizador de Equipo Electrónico', path: '/tecnologia/cotizarEquipoElectronico' },
                    { text: 'Valor de tu dispositivo', path: '/tecnologia/valorEquipoElectronico' },
                    { text: 'Elegi un Plan', path: '/tecnologia/elegiPlan' },
                ],
                leadId: null,
                referente: null,
                medium: null,
                pas: null,
                goods: []
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Tecnología';
                const actualPath = '/tecnologia';
                let actualStep = 'quoted';
                const request = new SaveMultiQuoteNotificationsRequest();

                if (this.offer) {
                    actualStep = 'stepOffer';
                }

                request.quotationDetail = "Producto: " + defaultTitle
                    + " - Equipo: " + this.dataGood.productDescription
                    + " - Valor: " + this.rangeSelected.productDescription;

                request.lastName = this.tabOneWelcome.lastName;
                request.firstName = this.tabOneWelcome.firstName;
                request.phone = this.tabOneWelcome.areaCode + this.tabOneWelcome.telephone;
                request.mail = this.tabOneWelcome.email;
                request.quotePlan = this.plans.map(plan => plan.planDescription).join(' - ');

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultElectronicDeviceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'electronic-equipment-range-view',
                })
            },
            open: function () {
                this.$refs.modal.open();
            },
            close: function () {
                this.$refs.modal.close();
            },

            selectedPlans: function (quotationData) {
                // se le envia el pricingId del plan que se haya elegido
                var pricingId = parseInt(quotationData.pricingId[0])
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        this.$router.push({
                            name: 'ElectronicDeviceClientData'
                        });
                    }
                    else {

                        const eventData = {
                            'pas': this.pas,
                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                            'product': 'tecnologia',
                            'event': 'errorServidor',
                            'paso': 'cotizador-tecnologia-plan',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            },

            dataPlans: function () {
                var PlanData = sessionStorage.getItem("DataQuotation");
                if (PlanData != null) {
                    this.PlanJson = JSON.parse(PlanData);
                    if (this.offer) {
                        this.plans = [];
                        this.modulesPlan = [];
                        this.plansLength = this.PlanJson.length;
                        this.PlanJson = this.PlanJson.sort((a, b) => a.plans[0].premioMensual - b.plans[0].premioMensual);
                        this.PlanJson.forEach((item, i) => {
                            const plans = item.plans;
                            const modulePlan = item.modulesPlan;
                            modulePlan.forEach(m => m.suggestedPlan = false);
                            plans.forEach((plan) => {
                                const finallyCalculationResult = plan.finallyCalculationResult.find(o => o.detalleInt == 1);
                                Object.assign(plan, modulePlan[0], finallyCalculationResult);
                                this.formatValues(plan);
                                plan.planDescription = "Plan " + (i + 1);
                                this.plans.push(plan);
                                this.modulesPlan.push(modulePlan[0]);
                            });
                        });
                    }
                    else {
                        const { plans, modulesPlan } = this.PlanJson[0];
                        this.plansLength = plans.length;
                        this.plans = plans;
                        this.modulesPlan = modulesPlan;

                        plans.forEach((plan, i) => {
                            const finallyCalculationResult = plan.finallyCalculationResult.find(o => o.detalleInt == 1);
                            Object.assign(plan, modulesPlan[i], finallyCalculationResult);
                            this.formatValues(plan);
                        });
                    }
                }
                this.getCoverNote();
            },

            formatValues: function (plan) {
                ['premioMensual', 'premiumWithoutDiscount', 'capital'].forEach(field => {

                    let value = plan[field];
                    if (value == null) return;

                    if (typeof value === 'string') {
                        value = value.replace(/\./g, '');
                    }

                    value = Number(value);
                    if (!isNaN(value)) {
                        plan[field] = value.toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0
                        });
                    }
                });
            },

            getCoverNote: function () {
                var productId = 1000;
                var securityGroup = '';
                let userName = '';
                let userToken = '';
                let tokenType = "";
                let correlationInformation = "";
                let onDate = new Date().toISOString();
                return new Promise<any>(async (resolve) => {
                    coverNoteService.getCoverNote(onDate, productId, securityGroup, correlationInformation, userName, userToken, tokenType)
                        .then(response => {
                            if (response) {
                                this.coberturas = response.filter(o => o.isChecked == true);
                                this.notCover = response.filter(o => o.isChecked == false);
                                sessionStorage.setItem("cover", JSON.stringify(this.coberturas || []));
                                sessionStorage.setItem("notCover", JSON.stringify(this.notCover || []));
                            }
                            else {
                                NF.UI.Page.unblock();
                            }
                        })
                    resolve(true);
                })
            },
            getInitData() {
                if (this.offer) {
                    const OffersSettings = JSON.parse(this.offer.OffersSettings);
                    var body = JSON.stringify({
                        goodTypeId: parseInt(this.dataGood.code),
                        rangeId: this.rangeSelected.code,
                        moduleCode: [OffersSettings.Modulo[0]],
                        cityId: OffersSettings.CityId,
                        zipCode: OffersSettings.Codigo_Postal
                    });
                    theftQuotationService.createTheft1000Quotation(body).then(async responseElectronicEquipmentQuotation => {
                        this.cotizarOffers(responseElectronicEquipmentQuotation).then(() => {
                            responseElectronicEquipmentQuotation = this.quotationDataResult;
                            sessionStorage.removeItem("DataQuotation");
                            sessionStorage.setItem("DataQuotation", JSON.stringify(responseElectronicEquipmentQuotation));

                            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                            sessionStorage.removeItem("pressBack");
                            var fromTabPassFour = sessionStorage.getItem("FromTabPassFour");
                            var fromTabPassFour = sessionStorage.getItem("FromTabPassFour");
                            var fromTabFive = sessionStorage.getItem("FromTabFive");
                            this.dataPlans();
                            this.offerVisible = true;
                            NF.UI.Page.unblock();
                        });
                    });
                }
                else {
                    this.tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                    this.dataGood = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                    this.rangeSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                    this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                    this.descriptionPlanNote = this.dataGood.planNote;
                    const additionalInformation = {
                        'Producto': this.dataGood.productDescription,
                        'Suma asegurada': this.rangeSelected.productDescription,
                    };
                    CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.tabOneWelcome.email, location.href, this.tabOneWelcome.areaCode, this.tabOneWelcome.telephone, 1000, false, "4", additionalInformation, this.tabOneWelcome.lastName, this.tabOneWelcome.firstName);
                    this.dataPlans();
                    window.globalThis.dataLayer = window.globalThis.dataLayer || [];

                    const eventData = {
                        'pas': this.pas,
                        'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                        'product': 'tecnologia',
                        'event': 'cotizador-tecnologia-valor',
                        'referente': this.referente,
                        'medio': this.medium
                    };

                    window.globalThis.dataLayer.push(eventData);

                    const customWindow = window as typeof window & {
                        _qsie?: Array<typeof eventData>;
                    };

                    customWindow._qsie ??= [];
                    customWindow._qsie.push(eventData);

                    sessionStorage.removeItem("pressBack");
                    var fromTabThree = sessionStorage.getItem("FromTabThree");
                    var fromTabFour = sessionStorage.getItem("FromTabFour");
                    if (fromTabThree == "true" && fromTabFour == "true") {
                        sessionStorage.setItem("FromTabThree", "false");
                    } else {
                        sessionStorage.setItem("FromTabThree", "false");
                        sessionStorage.setItem("FromTabFour", "true");
                    }
                }
            },
            InitTabsOffer() {
                const OffersSettings = JSON.parse(this.offer.OffersSettings);
                this.tabOneWelcome = {
                    firstname: "aaa",
                    lastname: "bbb",
                    areaCode: "",
                    telephone: "",
                    email: "",
                    zipCode: ""
                };
                sessionStorage.setItem("TabOneWelcome", JSON.stringify(this.tabOneWelcome));

                const item = this.goods.find(g => g.code === OffersSettings.Tipo_de_bien);
                let planNote = item.planNotes;
                this.dataGood = {
                    "code": OffersSettings.Tipo_de_bien,
                    "fromTab": "tab-two",
                    "planNote": planNote,
                    "productDescription": item.productDescription
                };
                this.descriptionPlanNote = planNote;
                sessionStorage.setItem("ProductDataSelected", JSON.stringify(this.dataGood));

                this.rangeSelected = {

                    "code": OffersSettings.Valor_del_bien[0],
                    "fromTab": "tab-three",
                    "productDescription": "Entre $200.000 y $450.000"
                };
                sessionStorage.setItem("ProductValueSelected", JSON.stringify(this.rangeSelected));
            },
            getGoodTypes: async function () {
                var productId = 1000;
                var securityGroup = '';
                let onDate = new Date().toISOString();
                let correlationInformation = "";
                let userName = '';
                let userToken = '';
                let tokenType = "";

                const response = await GoodTypesService.getGoodTypes(
                    productId,
                    securityGroup,
                    onDate,
                    correlationInformation,
                    userName,
                    userToken,
                    tokenType
                );

                this.goods = response.map(element => ({
                    ...element,
                    code: element.goodTypeId,
                    productDescription: element.goodTypeDescription,
                }));
            },
            async cotizarOffers(responseElectronicEquipmentQuotation) {
                const OffersSettings = JSON.parse(this.offer.OffersSettings);
                const { plans, modulesPlan } = responseElectronicEquipmentQuotation;
                const plansData = { plans, modulesPlan };
                this.quotationDataResult.push(plansData);

                const count = OffersSettings.Valor_del_bien.length;
                const requests: Promise<any>[] = [];
                var rangeId = this.range;
                for (let i = 1; i < count; i++) {
                    var body = JSON.stringify({
                        goodTypeId: parseInt(OffersSettings.Tipo_de_bien),
                        rangeId: OffersSettings.Valor_del_bien[i],
                        moduleCode: [OffersSettings.Modulo[i]],
                        cityId: OffersSettings.CityId,
                        zipCode: OffersSettings.Codigo_Postal,
                        quotationId: responseElectronicEquipmentQuotation.quotationId,
                        relationId: responseElectronicEquipmentQuotation.relationId,
                    });

                    requests.push(theftQuotationService.createTheft1000Quotation(body));
                }

                var responses = await Promise.all(requests);

                for (const res of responses) {
                    const { plans, modulesPlan } = res;
                    const plansData = { plans, modulesPlan };
                    this.quotationDataResult.push(plansData);
                }
                sessionStorage.setItem("DataQuotation", JSON.stringify(this.quotationDataResult));
            },
        },
        async mounted() {
            try {
                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
                var medium = sessionStorage.getItem("Medium");
                medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

                if (this.offer) {
                    NF.UI.Page.block({
                        message: [
                            {
                                text: "Estamos buscando tu mejor cotización.",
                                spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>',
                            },
                            {
                                text: "Aquí viene el segundo mensaje",
                                spin: '<i class="fa fa-circle-o-notch fa-spin fa-3x"></i>',
                            },
                            {
                                text: "Este es el tercer y último mensaje de la serie",
                                spin: '<i class="fa fa-asterisk fa-spin fa-3x"></i>',
                            },
                        ]
                    });
                    this.offerVisible = false;
                    const rutaAlternativa = sessionStorage.getItem("rutaAlternativa");
                    sessionStorage.clear();
                    this.isOffer = true;
                    sessionStorage.setItem("isOffer", this.isOffer)
                    this.getGoodTypes().then(() => {
                        this.InitTabsOffer();
                        this.pageCustomization().then(() => {
                            DiscountRangeService.getElectronicEquipmentDiscountRange().then(() => {
                                sessionStorage.setItem("rutaAlternativa", rutaAlternativa);
                                this.getInitData();
                                this.updateByProductGoogleAnalytics();
                            });
                        });
                    });
                }
                else {
                    NF.UI.Page.block();

                    const parallelPromises = [
                        this.getInitData(),
                        this.updateByProductGoogleAnalytics()
                    ];
                    await Promise.all([
                        ...parallelPromises,
                    ]);
                    await this.pageCustomization();

                    NF.UI.Page.unblock();
                }
            } catch {
                NF.UI.Page.unblock();
            }
        },
    })
